import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from "typeorm";
import { CommonColumns } from "./common-columns.entity";
import { CxQuestion } from "./cx-question.entity";
import { CxQuestionHeader } from "./cx-question-header.entity";
// import { Shop } from "./shop.entity";
// CxQuestionPageはCxShopにもBranchesにも紐づかない

@Entity()
export class CxQuestionPage extends CommonColumns {

  @Column()
  title: string;

  @Column({ name: 'disp_order', })
  dispOrder: number;

  @ManyToOne(() => CxQuestionHeader, cxQuestionHeader => cxQuestionHeader.cxQuestionPages, { nullable: false, })
  @JoinColumn({ name: 'cx_question_header_id', referencedColumnName: 'id', })
  cxQuestionHeader: CxQuestionHeader;

  @OneToMany(() => CxQuestion, cxQuestion => cxQuestion.cxQuestionPage)
  cxQuestions: CxQuestion[];

  constructor(props: TCxQuestionPage) {
    super();
    Object.assign(this, props);
  }
}

export declare type TCxQuestionPage = Omit<CxQuestionPage, 'dummy-no-such-field'>;
export interface ICxQuestionPage extends TCxQuestionPage {};
